import { z } from 'zod'
import {
  abstractComponent,
  COMPONENT_TYPES,
} from '@customTypes/cloudmix/sessions/components/base'
import {
  mixerInputPadSchema,
  mixerOutputPadSchema,
  projectMixerInputPadSchema,
} from '@customTypes/cloudmix/sessions/pads'
import { sceneSchema } from './scene'

export const baseMixerComponentSchema = abstractComponent.extend({
  type: z.literal(COMPONENT_TYPES.mixer).default(COMPONENT_TYPES.mixer),
  output: mixerOutputPadSchema,
  defaultSceneTransitionDurationMs: z.number().nullish(),
  scenes: sceneSchema.array().nullish(),
  recordingEnabled: z.boolean().nullish(),
})
export type BaseMixerComponent = z.infer<typeof baseMixerComponentSchema>

export const projectMixerComponentSchema = baseMixerComponentSchema.extend({
  inputs: projectMixerInputPadSchema.array(),
})
export type ProjectMixerComponent = z.infer<typeof projectMixerComponentSchema>

export const mixerComponentSchema = baseMixerComponentSchema.extend({
  inputs: mixerInputPadSchema.array(),
})
